import type { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import Sentry from "@similarweb/sentry-logger";

import { getCampaignsFromServer } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsContextUtils";
import type { IKeywordsCampaignData } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignTypes";
import {
    ALL_CAMPAIGNS_QUERY_PREFIX,
    RankTrackerQueryType,
} from "app/pages/digital-marketing/keywords-campaigns/shared/constants";
import { createCampaignQueryKey } from "app/pages/digital-marketing/keywords-campaigns/shared/utils";

import { useRankTrackerQuery } from "../useRankTrackerQuery";

type QueryOptions = Omit<UseQueryOptions<IKeywordsCampaignData[]>, "queryKey" | "queryFn">;

const CAMPAIGNS_QUERY_KEY: QueryKey = createCampaignQueryKey(
    ALL_CAMPAIGNS_QUERY_PREFIX,
    RankTrackerQueryType.Campaigns,
);

export const useCampaignsQuery = (options?: QueryOptions) => {
    return useRankTrackerQuery({
        queryKey: CAMPAIGNS_QUERY_KEY,
        queryFn: () => getCampaignsFromServer(),
        throwOnError: (error) => {
            Sentry.errorTracker({
                e: error,
                level: "error",
                message: "Error fetching campaigns configurations",
            });
            return false;
        },
        ...options,
    });
};
